/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC, useEffect} from 'react'
import {Navigate, Routes, Route} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {MasterLayout} from '../../cms/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {Logout, AuthPage} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {RootState} from '../../setup'
import {MasterInit} from '../../cms/layout/MasterInit'
import {NewPassword} from '../modules/auth/components/NewPassword'
import Callback from '../modules/auth/Callback'

// First, let's check your callback route configuration in AppRoutes:

const AppRoutes: FC = () => {
  const authState = useSelector<RootState>(state => state.auth, shallowEqual)
  const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)



  return (
    <>
      <Routes>
        {!isAuthorized ? (
          <>
            <Route path='/auth/*' element={<AuthPage />} />
            <Route path='/error/*' element={<ErrorsPage />} />
            <Route path='/logout' element={<Logout />} />
            
            {/* 🚨 CRITICAL: Add callback route for unauthenticated users */}
            <Route path='/callback' element={<Callback />} />
            
            <Route path='/sso' element={<Navigate to='/auth/sso' replace />} />
            <Route path='*' element={<Navigate to='/auth/login' replace />} />
          </>
        ) : (
          <>
            <Route path='/auth/*' element={<Navigate to='/' />} />
            <Route path='/error/*' element={<ErrorsPage />} />
            <Route path='/signout-callback-oidc' element={<Logout />} />
            
            {/* Callback for authenticated users (shouldn't normally hit this) */}
            <Route path='/callback' element={<Navigate to='/' />} />
            
            <Route path='/sso' element={<Navigate to='/' />} />
            <Route element={<MasterLayout />}>
              <Route path='/*' element={<PrivateRoutes />} />
            </Route>
          </>
        )}
      </Routes>
      <MasterInit />
    </>
  )
}

export {AppRoutes as Routes}
